function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVickybohoShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-f284aa28-29e9-4b17-8e66-ca6568b2f177",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 75.23 63.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M5.51,26.35c-3.04,0-5.51,2.47-5.51,5.51s2.47,5.51,5.51,5.51,5.51-2.47,5.51-5.51-2.47-5.51-5.51-5.51ZM53.2,0h-5.75l22.03,31.63-22.03,31.63h5.75l22.03-31.63L53.2,0ZM19.17,0l22.03,31.63-22.03,31.63h5.75l22.03-31.63L24.92,0h-5.75Z",
    style: {
      fillRule: "evenodd"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVickybohoShare);
export default __webpack_public_path__ + "static/media/vicky boho - share.c0d904a738743fe3056490d192d6bf74.svg";
export { ForwardRef as ReactComponent };